module.exports = __webpack_public_path__ + "static/media/logo_memoryMee.e68ef1ef.png";